import { useEffect, useRef } from "react";
import { Lock, RefreshCw } from "lucide-react";

import { Footer } from "@/components/Frame";
import { money } from "@/lib/validators";

const MP_SDK_SRC = "https://sdk.mercadopago.com/js/v2";

export function Checkout({
  mode,
  setMode,
  total,
  paying,
  onPay,
}: {
  mode: "annual" | "monthly";
  setMode: (v: "annual" | "monthly") => void;
  total: string;
  paying: boolean;
  onPay: () => void;
}) {
  const cardMount = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (document.querySelector(`script[src="${MP_SDK_SRC}"]`)) return;
    const s = document.createElement("script");
    s.src = MP_SDK_SRC;
    s.async = true;
    s.crossOrigin = "anonymous";
    document.head.appendChild(s);
  }, []);

  return (
    <>
      <div className="screen">
        <h1 className="h1">Confirma y paga</h1>

        <div className="totals" style={{ marginTop: 18 }}>
          <div className="trow trow--total">
            <span className="trow__k">Total a pagar</span>
            <span className="trow__v tnum">{money(total)}</span>
          </div>
        </div>

        <div className="eyebrow" style={{ marginTop: 24 }}>
          Modalidad
        </div>
        <div className="opt-group">
          <label className={"opt" + (mode === "annual" ? " opt--on" : "")}>
            <input
              type="radio"
              name="mode"
              checked={mode === "annual"}
              onChange={() => setMode("annual")}
            />
            <span className="opt__body">
              <span className="opt__title">Pago único anual</span>
              <span className="opt__sub">Acceso inmediato por 12 meses.</span>
            </span>
          </label>
          <label className={"opt" + (mode === "monthly" ? " opt--on" : "")}>
            <input
              type="radio"
              name="mode"
              checked={mode === "monthly"}
              onChange={() => setMode("monthly")}
            />
            <span className="opt__body">
              <span className="opt__title">Suscripción mensual</span>
              <span className="opt__sub">
                Cobro automático cada mes, cancelable cuando quieras.
              </span>
            </span>
          </label>
        </div>

        <div className="eyebrow" style={{ marginTop: 24 }}>
          Método de pago
        </div>
        <div className="mp-mount" ref={cardMount}>
          <div className="mp-placeholder">
            <Lock size={20} strokeWidth={1.6} /> Tu información viaja cifrada
            directo a MercadoPago.
          </div>
        </div>
      </div>
      <Footer>
        <button
          className="btn btn--primary btn--block"
          disabled={paying}
          onClick={onPay}
        >
          {paying ? (
            <>
              <RefreshCw size={18} className="spin" /> Procesando…
            </>
          ) : (
            <>Pagar {money(total)}</>
          )}
        </button>
      </Footer>
    </>
  );
}
